import React from 'react'
import classNames from 'classnames'
import { NextPage } from 'next'
import { HeadingLG, ParagraphLG } from '@/atoms/Text'
import { useUserRegion } from '@/services/UserRegionService'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GuildNowStreamingRail } from '@/views/GuildSignupView/GuildBodySection/GuildNowStreamingRail'
import { AppPromoSection } from '@/views/LandingView/AppPromoSection'

export const WhatsInMyRegionPage: NextPage = () => {
  const { region, loading } = useUserRegion()
  const { t } = useTranslate('guild')
  return (
    <div>
      <section className="px-4 pt-[104px] md:px-8">
        <HeadingLG weight="bold" color="white">
          <Translate t={t} i18nKey="checkOutWhatsStreaming">
            Check Out What&apos;s Streaming on Angel
          </Translate>
        </HeadingLG>
        <div className={classNames({ 'opacity-0': loading })}>
          <ParagraphLG weight="normal" color="core-gray-300" className="py-8">
            <Translate t={t} i18nKey="weStriveToMakeShowsAvaialble" values={{ region }}>
              We strive to make our shows as widely available as possible but some titles may not be available
              everywhere. Below you can see everything available for streaming to Guild members in your region, which
              appears to be <span className="font-bold text-white">{{ region }}</span>.
            </Translate>
          </ParagraphLG>
          <GuildNowStreamingRail title={t('nowStreamingInRegion', 'Now Streaming in {{region}}', { region })} />
        </div>
      </section>
      <AppPromoSection containerClassName="h-full pt-10 !pb-0" simplified />
    </div>
  )
}

export const getStaticPaths = getGenericStaticPaths

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/whats-in-my-region/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, ['common', 'app-promo', 'account', 'guild'])),
      },
      revalidate: false,
    }
  },
)

export default WhatsInMyRegionPage
